import React, { useEffect, useState } from "react";

import { Strings } from "--root/strings/en";
import { Heading5 } from "--components/typography";
import { SurfaceBody, SurfaceHeader } from "--floponents-web/atoms/Surface";
import { DialogCloseButton } from "--floponents-web/molecules/DialogCloseButton/DialogCloseButton";

import { useCemJob } from "./useCemJob";
import { CemStatusDialogBodyLoading } from "./CemStatusDialogBodyLoading";
import { CemStatusDialogBodyJob } from "./CemStatusDialogBodyJob";
import { CemStatusDialogBodyAttach } from "./CemStatusDialogBodyAttach";
import { TopicTypeStreamExtra } from "--client/../static_types/topic.types";
import { DisplayNameFromID } from "--floponents-web/atoms/DisplayName";
import styled from "styled-components";


export interface CemStatusDialogProps {
    streamId: string;
    spaceId: string;
    mutable: boolean;
    topicType: TopicTypeStreamExtra
    onClose?: () => void;
}
const StyledAdoptionInfo = styled.div`
    display:flex;
    align-items:center;
    justify-content:start;
    ${p => p.theme.typography.body1};
    margin:0;
    gap:${p => p.theme.spacing(0.5)};
    color:${p => p.theme.palette.text.secondary};
`
export const CemStatusDialog = (props: CemStatusDialogProps) => {
    const cemJob = useCemJob(props.streamId);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setIsLoading(cemJob === undefined);
    }, [cemJob])
    return (
        <>
            <SurfaceHeader>
                <Heading5>{Strings.inline("CEM Status")}</Heading5>
                <DialogCloseButton onClick={props.onClose} />
            </SurfaceHeader>
            <SurfaceBody>
                {
                    props.topicType.adoption_info?.adopted_by
                        ? <StyledAdoptionInfo>Adopted by: <DisplayNameFromID
                            userId={props.topicType.adoption_info.adopted_by}
                            includePrefix
                        /></StyledAdoptionInfo>
                        : null
                }
                {
                    (
                        () => {
                            if (isLoading)
                                return <CemStatusDialogBodyLoading />
                            else if (cemJob)
                                return <CemStatusDialogBodyJob {...props} cemJob={cemJob} />
                            else if (props.mutable)
                                return <CemStatusDialogBodyAttach {...props} />
                            return null
                        }
                    )()
                }
            </SurfaceBody>
        </>
    );
};
